import { useTranslation } from 'next-i18next';
import cx from 'classnames';
import { Icon } from '@dx-ui/osc-icon';
import { Heading, Link, Text } from '@dx-ui/global-ui-prism';

export type TwoFactorAuthHelpProps = {
  /** Custom styles will apply to parent `<div />`. To style other parts of the component, pass in custom JSX to relevant props */
  className?: string;
  /** Fallback heading is: h3 tag with text “Need help with your security code?” */
  heading?: React.ReactNode;
  /** Fallback subheading is: “Call us and we’ll help you set up your security options.” */
  subHeading?: string;
  /** Fallback content is: “US and Canada | 1-800-817-5143” */
  content?: React.ReactNode;
  /** Flag to hide the link */
  hideLink?: boolean;
};

export const TwoFactorAuthHelp = ({
  className,
  heading,
  subHeading,
  content,
  hideLink = false,
}: TwoFactorAuthHelpProps) => {
  const [t] = useTranslation('osc-two-factor-auth');
  return (
    <div className={cx('mx-auto flex max-w-fit flex-col items-center', className)}>
      {heading ? (
        heading
      ) : (
        <Heading level={3} size="lg" className="text-surface-accent">
          {t('helpHeading')}
        </Heading>
      )}
      <Text size="lg" className="mt-2">
        {subHeading ? subHeading : t('helpSubHeading')}
      </Text>
      <div className="mt-10 flex w-full justify-center gap-x-1 bg-surface-legacy py-5">
        <Icon name="telephone" variant="solid" size="sm" />
        <div>
          <Text>{content ? content : t('usAndCanadaNumber')}</Text>
          {hideLink ? null : (
            <Link url="https://help.hilton.com/s/article/Global-support-numbers">
              {t('findInternationalNumbers')}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
